import { useMediaDevices } from "@/utils/hooks/useMediaDevices";
export interface LVideoSectionProps {
  id?: string;
  videoUrl?: string;
  mobileVideoUrl?: string;
}

export function LVideoSection(props: LVideoSectionProps) {
  const { isMobile } = useMediaDevices();

  return (
    <div className="relative w-full h-screen video-container" id={props?.id}>
      <div className="order-3 relative top-0 left-0 w-full h-full overflow-hidden text-white">
        <div className="w-full h-full">
          <video
            loop
            muted
            autoPlay
            playsInline
            src={isMobile ? props.mobileVideoUrl : props.videoUrl}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>
      </div>
    </div>
  );
}

export default LVideoSection;
